export const USER_NOTIFICATIONS_EVENT = "lotq:user-notifications";

export function emitUserNotificationState(payload) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(USER_NOTIFICATIONS_EVENT, { detail: payload || {} }));
}
